import React from 'react';
import { PhoneIcon, LinkedinIcon, FacebookIcon, InstagramIcon, YoutubeIcon } from 'lucide-react';
import { Button } from '../../components/ui/Button';
export function HeaderDesktopUtility() {
  return <div className="hidden lg:flex flex-col items-end space-y-2" data-id="element-2698">
      <div className="flex items-center space-x-3" data-id="element-2699">
        <a href="https://www.linkedin.com/company/peak-machine-sales/" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-blue transition-colors" aria-label="LinkedIn" data-id="element-2700">
          <LinkedinIcon className="w-4 h-4" data-id="element-2701" />
        </a>
        <a href="https://www.facebook.com/PeakMachineSales/" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-blue transition-colors" aria-label="Facebook" data-id="element-2702">
          <FacebookIcon className="w-4 h-4" data-id="element-2703" />
        </a>
        <a href="https://www.instagram.com/peak_machine_sales/" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-blue transition-colors" aria-label="Instagram" data-id="element-2704">
          <InstagramIcon className="w-4 h-4" data-id="element-2705" />
        </a>
        <a href="https://www.youtube.com/channel/UCG3x08N2riAd1G2e9-driYA" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-blue transition-colors" aria-label="YouTube" data-id="element-2706">
          <YoutubeIcon className="w-4 h-4" data-id="element-2707" />
        </a>
      </div>
      <div className="flex items-center space-x-4" data-id="element-2708">
        <a href="tel:2483800871" className="flex items-center text-sm text-navy hover:text-orange transition-colors font-medium" aria-label="Call Peak Machine Sales" data-id="element-2709">
          <PhoneIcon className="w-4 h-4 mr-1" data-id="element-2710" />
          <span data-id="element-2711">(248) 380-0871</span>
        </a>
        <Button variant="primary" href="/ContactPeakMachineSales.html" size="md" className="text-sm px-5 py-2" data-id="element-2712">
          Contact / Get a Quote
        </Button>
      </div>
    </div>;
}